import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MobileOverlayCardComponent } from '@prlw/common/mobile-overlay-card/mobile-overlay-card.component';
import { Instrument } from '@prlw/core/monitor/instrument.entity';
import { CommonModule } from '@angular/common';
import { BasisDetailsModule } from '../basis-details/basis-details.module';
import { ResponsiveDirective } from '@prlw/libs/responsive/responsive.directive';
import { ScrollAnchorService } from '@prlw/libs/scroll-anchor/scroll-anchor.service';
import { TextTagOtpComponent } from '../../text-tag-otp/text-tag-otp.component';

@Component({
  selector: 'prlw-basis-details-mobile-ui',
  standalone: true,
  imports: [
    CommonModule,
    MobileOverlayCardComponent,
    BasisDetailsModule,
    ResponsiveDirective,
    TextTagOtpComponent,
  ],
  providers: [ScrollAnchorService],
  templateUrl: './basis-details-mobile.component.html',
  styleUrl: './basis-details-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisDetailsMobileComponent {
  @Input() item: Instrument | null = null;

  @Output() eventClickAboutBasis = new EventEmitter<void>();
  @Output() eventClose = new EventEmitter<void>();
}
